import * as authConstants from './authConstants';


/**
 * @param auth {object} Auth response from the IdP
 * @return {{payload, type: string}}
 */
export const onAuthSuccess = auth => {

    return {
        payload: auth,
        type: authConstants.ACTION_AUTH_SUCCESSFUL
    };
};


/**
 * @param auth {object} Auth response from the IdP
 * @return {{payload, type: string}}
 */
export const onAuthRefreshError = auth => {

    return {
        payload: null,
        type: authConstants.ACTION_AUTH_LOGOUT
    };
};


/**
 * @param auth {object} Auth response from the IdP
 * @return {{payload, type: string}}
 */
export const onAuthRefreshSuccess = auth => {

    return {
        payload: auth,
        type: authConstants.ACTION_AUTH_REFRESH_SUCCESSFUL
    };
};


/**
 * @return {{payload, type: string}}
 */
export const onAuthLogout = () => {

    return {
        payload: null,
        type: authConstants.ACTION_AUTH_LOGOUT
    };
};
